import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

import { StoreService } from 'shared/services/store.service';
import { isLocalEnv } from 'app/utils/environment-utils'
import { LoadingService } from './loading.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'arbhs-frontend';
  currentYear = new Date().getFullYear();
  isGarant = window.location.href.includes('garant');

  constructor(
    private router: Router,
    private storeService: StoreService,
    public loadingService: LoadingService
  ) { }

  ngOnInit(): void {
    this.router.events.pipe(
      filter((event: any) => event instanceof NavigationEnd),
      filter((event: any) => event.url.includes('stammdaten'))
    ).subscribe(() => {
      this.storeService.resetCurrentDataItems();
      this.storeService.setFormReady(false);
    });
    const isLocal = isLocalEnv();
    const shouldInjectAnalytics = !isLocal;
    if (shouldInjectAnalytics) {
      this.injectAnalyticsScript();
    }
  }

  injectAnalyticsScript() {
    const script = document.createElement('script');
    script.src = 'https://digistats.de/js/script.js';
    script.async = true;
    script.defer = true;

    script.id = 'ZwSg9rf6GA';
    script.setAttribute('data-host', 'https://digistats.de');
    script.setAttribute('data-dnt', 'false')

    document.head.appendChild(script);
  }
}
